import React, { Component } from 'react';
import PropTypes from 'prop-types';

import GrayPanel from '../../components/GrayPanel';
import ModalAlert from '../../components/ModalAlert';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';

import Select from 'react-select';
import { throws } from 'assert';

import v from './validators';

class InvestContactForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name_investor: null,
      company_activity_subject: null,

      name_contact: null,
      phone: null,
      email_contact: null,

      plot: null,
      mpzp: null,
      area_build: null,
      gas: null,
      electricity: null,
      water: null,
      other_requirement: null,
      planned_buy_plot: null,
      description_invest: null,
      additional: null,

      teryt: null,

      errors: {},
      errorTitle: '',
      errorText: '',
      showError: false,
    };

    this.validators = {
      name_investor: [v.NotNull],
      company_activity_subject: [v.NotNull],
      name_contact: [v.NotNull],
      phone: [v.isNumber],
      email_contact: [v.CheckEmail],
      mpzp: [v.NotSelected],
      plot: [v.NotNull, v.isNumber],
      area_build: [v.NotNull, v.isNumber],
      gas: [v.isNumber],
      electricity: [v.isNumber],
      water: [v.isNumber],
      planned_buy_plot: [v.NotNull]
    };

    this.errorSpanStyle = {
      color: 'red',
      fontSize: '10px',
    };

    this.inputStyle = { borderRadius: '0' };
  }

  componentDidMount() {
    // Pobieram teryt z linku i przypisuje do state
    const url_string = window.location.href;
    const url = new URL(url_string);
    const c = url.searchParams.get('district');

    this.setState({
      teryt: c,
    });
  }

  insertTestData = () => {
    this.setState({
      name_investor: 'test investor',
      company_activity_subject: 'jakis przediomt',

      name_contact: 'Krzysztof Gregorowicz',
      phone: '787214929',
      email_contact: 'gregorowicz.k@gmail.com',

      plot: 551321,
      mpzp: 'Inne',
      area_build: 13532,
      planned_buy_plot: 'planned buy plot',
      other_requirement: "inne wymagania",
      description_invest: 'to jest bardzo ciekawy opis investycji',
    });
  };

  handleChangeSelect = (e, name) => {
    this.setState({
      [name]: e.value,
    },
      () => this.validate(name),
    );
  };

  htmlDecode(input) {
    if (typeof window !== 'undefined') {
      var e = document.createElement('div');
      e.innerHTML = input;
      return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }
  }

  handleChange = (e, name) => {
    this.setState({
      [name]: e.target.value,
    },
      () => this.validate(name),
    );
  };

  validateField = (field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validate = (field, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    }
    else {
      let errors = {...this.state.errors};
      for (const field of Object.keys(this.validators)){
        const checks = this.validateField(field);
        errors = {...errors, [field]: checks};
      }
      newState = {
        errors: {
          ...errors
        },
      };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  onHide = () => this.setState({ showError: false });

  runService = () => {
    const data = {
      service_data: {
        inwestor: this.state.name_investor,
        main_products: this.state.company_activity_subject,

        name_contact: this.state.name_contact,
        phone: this.state.phone,
        email: this.state.email_contact,

        plot: this.state.plot,
        mpzp: this.state.mpzp,
        area_build: this.state.area_build,
        gas: this.state.gas ? this.state.gas : null,
        eletricity: this.state.electricity ? this.state.electricity : null,
        water: this.state.water ? this.state.water : null,
        other_requirement: this.state.other_requirement ? this.state.other_requirement : null,
        planned_buy_plot: this.state.planned_buy_plot,
        description: this.state.description_invest,
        additional: this.state.additional,

        teryt: this.state.teryt,
        fk_userID: this.props.serviceInfo.user.ID,
        short_name: 'invest_contact_form',
      },
      user: { ...this.props.serviceInfo.user },
    };
    const url = `${process.env.API_URL}/invest/create_topic_new`;
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, */*',
      },
      body: JSON.stringify(data),
    })
      .then(r => r.json())
      .then(resp => {
        window.location.href = `${process.env.API_URL}/eservices/signDoc/${resp.jobId}`;
      });

  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Formularz zawiera błędy.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true
      });
      return;
    }

    if (!hasFieldErrors) {
      this.runService()
    }
  }

  startService = () => {
    this.validate(null, this.postValidation);
  };

  render() {
    // layout classes
    const labelCol = 'col-sm-2';
    const inputCol = 'col-sm-7';

    // really simple styles
    const labelStyle = { marginTop: '.5rem' };
    const rowStyle = { marginTop: '15px' };

    const optionsMPZP = [
      {
        label: 'Produkcja',
        value: 'Produkcja',
      },
      {
        label: 'Składy i magazyny',
        value: 'Składy i magazyny',
      },
      {
        label: 'Usługi',
        value: 'Usługi',
      },
      {
        label: 'Budownictwo wielorodzinne',
        value: 'Budownictwo wielorodzinne',
      },
      {
        label: 'Handel',
        value: 'Handel',
      },
      {
        label: 'Drobna wytwórczość',
        value: 'Drobna wytwórczość',
      },
      {
        label: 'Handel wielkopowierzchniowy',
        value: 'Handel wielkopowierzchniowy',
      },
      {
        label: 'Inne',
        value: 'Inne',
      },
    ];

    // dane inwestora
    this.optionsInvestor = [
      {
        label: 'Nazwa inwestora', // Nazwa wyświetlana
        state: this.state.name_investor, // Jaki state bedzie trzymal dane
        name_state: 'name_investor', // Nazwa state'a zeby zmieniac
        placeholder: 'Nazwa inwestora...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Główny przedmiot działalności firmy', // Nazwa wyświetlana
        state: this.state.company_activity_subject, // Jaki state bedzie trzymal dane
        name_state: 'company_activity_subject', // Nazwa state'a zeby zmieniac
        placeholder: 'Główne przedmiot działalności firmy...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami,
      },
    ];

    // Pola z danymi kontaktowymi
    this.dataContact = [
      {
        label: 'Imię i nazwisko', // Nazwa wyświetlana
        state: this.state.name_contact, // Jaki state bedzie trzymal dane
        name_state: 'name_contact', // Nazwa state'a zeby zmieniac
        placeholder: 'Imię i nazwisko...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami
      },
      {
        label: 'Numer telefonu', // Nazwa wyświetlana
        state: this.state.phone, // Jaki state bedzie trzymal dane
        name_state: 'phone', // Nazwa state'a zeby zmieniac
        placeholder: 'Numer telefonu...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami
      },
      {
        label: 'E-mail', // Nazwa wyświetlana
        state: this.state.email_contact, // Jaki state bedzie trzymal dane
        name_state: 'email_contact', // Nazwa state'a zeby zmieniac
        placeholder: 'E-mail...',
        type_input: 0, // 0 - zwykly input, 1 - React Select
        options: 0, // Tablica z wyborami
      },
    ];

    // Dane inwestycji
    this.optionsInvest = [
      {
        label: 'Poszukiwana powierzchnia terenu [ha]', // Nazwa wyświetlana
        state: this.state.plot, // Jaki state bedzie trzymal dane
        name_state: 'plot', // Nazwa state'a zeby zmieniac
        placeholder: 'Poszukiwana powierzchnia terenu [ha]...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Przeznaczenie terenu w miejscowym planie zagospodarowania przestrzennego', // Nazwa wyświetlana
        state: this.state.mpzp, // Jaki state bedzie trzymal dane
        name_state: 'mpzp', // Nazwa state'a zeby zmieniac
        placeholder: 'Forma nabycia nieruchomości...',
        type_input: 1, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: optionsMPZP, // Tablica z wyborami
      },
      {
        label: 'Powierzchnia budynku/budynków [m&lt;sup&gt;2&lt;/sup&gt;]', // Nazwa wyświetlana
        state: this.state.area_build, // Jaki state bedzie trzymal dane
        name_state: 'area_build', // Nazwa state'a zeby zmieniac
        placeholder: 'Powierzchnia budynku/budynków...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
        index_up: true
      },
      {
        label: 'Orientacyjne zapotrzebowanie: gaz [m&lt;sup&gt;3&lt;/sup&gt;/h]', // Nazwa wyświetlana
        state: this.state.gas, // Jaki state bedzie trzymal dane
        name_state: 'gas', // Nazwa state'a zeby zmieniac
        placeholder: 'Orientacyjne zapotrzebowanie: gaz...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Orientacyjne zapotrzebowanie: energia elektryczna [kW]', // Nazwa wyświetlana
        state: this.state.electricity, // Jaki state bedzie trzymal dane
        name_state: 'electricity', // Nazwa state'a zeby zmieniac
        placeholder: 'Orientacyjne zapotrzebowanie: energia elektryczna [kW]...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Orientacyjne zapotrzebowanie: woda [m&lt;sup&gt;3&lt;/sup&gt;/h]', // Nazwa wyświetlana
        state: this.state.water, // Jaki state bedzie trzymal dane
        name_state: 'water', // Nazwa state'a zeby zmieniac
        placeholder: 'Orientacyjne zapotrzebowanie: woda...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Inne wymagania', // Nazwa wyświetlana
        state: this.state.other_requirement, // Jaki state bedzie trzymal dane
        name_state: 'other_requirement', // Nazwa state'a zeby zmieniac
        placeholder: 'Inne wymagania...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Planowany termin nabycia gruntu', // Nazwa wyświetlana
        state: this.state.planned_buy_plot, // Jaki state bedzie trzymal dane
        name_state: 'planned_buy_plot', // Nazwa state'a zeby zmieniac
        placeholder: 'Planowany termin nabycia gruntu...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Krótki opis planowanej inwestycji', // Nazwa wyświetlana
        state: this.state.description_invest, // Jaki state bedzie trzymal dane
        name_state: 'description_invest', // Nazwa state'a zeby zmieniac
        placeholder: 'Krótki opis planowanej inwestycji...',
        type_input: 2, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
      {
        label: 'Dodatkowe informacje  (opcjonalnie)', // Nazwa wyświetlana
        state: this.state.additional, // Jaki state bedzie trzymal dane
        name_state: 'additional', // Nazwa state'a zeby zmieniac
        placeholder: 'Dodatkowe informacje...',
        type_input: 0, // 0 - zwykly input, 1 - React Select, 2 - Textarea
        options: 0, // Tablica z wyborami,
      },
    ];

    return (
      <div>
        <br />
        {this.props.serviceInfo.eservice.requiresUserInfo && this.props.serviceInfo.user ? (
          <div>
            <h3 style={{ textAlign: 'center' }}>
              {this.props.serviceInfo.eservice.title}
            </h3>
            <GrayPanel title="Dane inwestora">
              {this.optionsInvestor.map((v, i) => (
                <div key={i} className="row mobile-row container" style={rowStyle}>
                  <div className={labelCol}>
                    <label style={labelStyle} dangerouslySetInnerHTML={{ __html: this.htmlDecode(v.label) }} />
                  </div>
                  <div className={inputCol}>
                    {v.type_input == 0 ? (
                      <input
                        className="form-control"
                        style={{
                          width: '100%',
                          borderColor:
                            Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                              this.state.errors[v.name_state] !== null &&
                              this.state.errors[v.name_state].length > 0
                              ? 'red'
                              : '#ccc',
                        }}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChange(e, v.name_state)}
                      />

                    ) : null}
                    {/* RENDER ERROS IN SPAN */}
                    {Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                      this.state.errors[v.name_state] !== null &&
                      this.state.errors[v.name_state].length > 0
                      ? this.state.errors[v.name_state].map((val, index) => (
                        <span key={index} style={this.errorSpanStyle}>
                          {val}
                        </span>
                      ))
                      : null}
                  </div>
                </div>
              ))}

            </GrayPanel>

            <GrayPanel title="Dane kontaktowe">
              {this.dataContact.map((v, i) => (
                <div key={i} className="row mobile-row container" style={rowStyle}>
                  <div className={labelCol}>
                    <label style={labelStyle} dangerouslySetInnerHTML={{ __html: this.htmlDecode(v.label) }} />
                  </div>
                  <div className={inputCol}>
                    {v.type_input == 0 ? (
                      <input
                        className="form-control"
                        style={{
                          width: '100%',
                          borderColor:
                            Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                              this.state.errors[v.name_state] !== null &&
                              this.state.errors[v.name_state].length > 0
                              ? 'red'
                              : '#ccc',
                        }}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChange(e, v.name_state)}
                      />
                    ) : null}
                    {/* RENDER ERROS IN SPAN */}
                    {Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                      this.state.errors[v.name_state] !== null &&
                      this.state.errors[v.name_state].length > 0
                      ? this.state.errors[v.name_state].map((val, index) => (
                        <span key={index} style={this.errorSpanStyle}>
                          {val}
                        </span>
                      ))
                      : null}
                  </div>
                </div>
              ))}
            </GrayPanel>

            <GrayPanel title="Informacje dotyczące terenu">
              {this.optionsInvest.map((v, i) => (
                <div key={i} className="row mobile-row container" style={rowStyle}>
                  <div className={labelCol}>
                    <label style={labelStyle} dangerouslySetInnerHTML={{ __html: this.htmlDecode(v.label) }} />
                  </div>
                  <div className={inputCol}>
                    {v.type_input == 0 ? (
                      <input
                        className="form-control"
                        style={{
                          width: '100%',
                          borderColor:
                            Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                              this.state.errors[v.name_state] !== null &&
                              this.state.errors[v.name_state].length > 0
                              ? 'red'
                              : '#ccc',
                        }}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChange(e, v.name_state)}
                      />
                    ) : null}
                    {v.type_input == 1 ? (
                      <Select
                        clearable={false}
                        options={v.options}
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChangeSelect(e, v.name_state)}
                        style={{
                          borderColor:
                            Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                              this.state.errors[v.name_state] !== null &&
                              this.state.errors[v.name_state].length > 0
                              ? 'red'
                              : '#ccc',
                        }}
                        onBlur={event => event.preventDefault()}
                        optionClassName="needsclick"
                        blurInputOnSelect={false}
                      />
                    ) : null}
                    {v.type_input == 2 ? (
                      <textarea
                        className="form-control"
                        value={v.state}
                        placeholder={v.placeholder}
                        onChange={e => this.handleChange(e, v.name_state)}
                      />
                    ) : null}
                    {/* RENDER ERROS IN SPAN */}
                    {Object.keys(this.state.errors).indexOf(v.name_state) > -1 &&
                      this.state.errors[v.name_state] !== null &&
                      this.state.errors[v.name_state].length > 0
                      ? this.state.errors[v.name_state].map((val, index) => (
                        <span key={index} style={this.errorSpanStyle}>
                          {val}
                        </span>
                      ))
                      : null}
                  </div>
                </div>
              ))}
              <div className="row mobile-row pull-right">
                <button
                  className="btn btn-primary"
                  style={rowStyle}
                  onClick={() => this.startService()}
                >
                  Wyślij list intencyjny
                </button>
              </div>
              {this.props.serviceInfo.user &&
                this.props.serviceInfo.user.roles &&
                this.props.serviceInfo.user.roles.indexOf('superadmin') > -1 ? (
                  <button onClick={this.insertTestData} className="btn btn-primary">
                    Insert test data
                </button>
                ) : null}
              <EmptyFileDownloader className="btn btn-primary" position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            </GrayPanel>
          </div>
        ) : null}

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
      </div>
    );
  }
}

InvestContactForm.propTypes = {};

export default InvestContactForm;



// WEBPACK FOOTER //
// src/routes/eservices/InvestContactForm.js